import React, { useEffect, useState, useContext, useRef } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../helpers/axiosInstance';
import downloadImagesAndReplace, { strtr } from '../../helpers/BlobImages';
import { setCallUnsaveAlert } from '../../blocks/Header';
import { EditorState, convertFromHTML, ContentState } from 'draft-js';
import RichTextEditor, { decoratorPlugin } from '../Common/SharedComponents/RichTextEditor';
import { ReactSVG } from "react-svg";
import { stateFromHTML } from 'draft-js-import-html';
import { stateToHTML } from 'draft-js-export-html';
import {
  Image, Form, Button, Header, TextArea, Dropdown, Grid, Loader, Modal, Popup,
  TextAreaProps, DropdownProps, DropdownItemProps, Icon, List, Dimmer, Table,
  Message, Label
} from 'semantic-ui-react';
import ReactToPrint from 'react-to-print';
import { toast } from 'react-toastify';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import { clearInterval, setInterval } from 'worker-timers';
import ConstituentAutoComplete from '../pages/ConstituentAutoComplete';
import FileUploadMultiple from '../Common/SharedComponents/FileUploadMultiple';
import {
  CaseViewModel, AttachmentChangeViewModel, CaseRecordSuccessViewModel,
  IdNameViewModel, IdNameBoolViewModel, ConstituentViewModel, CaseNotesViewModel,
  CommunicationHistoryViewModel, UploadDocumentViewModel, CaseNoteViewModel, OtherCasesModel, DocumentViewModel,
  CaseImageViewModel
} from '../../types/ServerDTO';
import ExclamationIcon from "../../assets/images/exclamation-icon.svg";
import ExclamationActiveIcon from "../../assets/images/exclamation-active-icon.svg";
import ConstituentForm from './ConstituentForm';
import AppContext, { token_config } from '../../AppContext';
import _ from 'lodash';
import Swal from 'sweetalert2';
import type { SweetAlertOptions } from 'sweetalert2';
import UserInfo from '../Common/SharedComponents/UserInfo';
import SwitchTheme from '../Common/SharedComponents/SwitchTheme';
import moment from 'moment';
import 'draft-js/dist/Draft.css';
import onCompletedIcons from "../../assets/images/Status-completed-Icon.svg";
import onClosedIcons from "../../assets/images/Status-closed-Icon.svg";
import onNewFileIcons from "../../assets/images/Status-New-Icon.svg";
import onProgressIcons from "../../assets/images/Status-inprogress-Icon.svg";
import onAwaitingInfo from "../../assets/images/Status-Awaiting-info-Icon.svg";
import CaseNote from './CaseNote';
import CommunicationHistory from './CommunicationHistory';
import imageLogo from "../../assets/images/logo.svg";

type FormErrorFields = {
  subject: string;
  caseType: string;
  constituent: string;
  source: string;
  status: string;
  attachments: string;
};

type HistoryFormErrorFields = {
  communicationHistoryBody: string;
}

type NoteFormErrorFields = {
  notes: string;
}

let successCount = 0;
let draftIntervalId: number;
let draftEmail: CommunicationHistoryViewModel;
let oldDraftEmail: CommunicationHistoryViewModel;

const saveDraftEmailSeconds = process.env.REACT_APP_SAVE_DRAFT_EMAIL_SECONDS !== undefined ? process.env.REACT_APP_SAVE_DRAFT_EMAIL_SECONDS : 30;

export const CaseForm: React.FC = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  const caseNumber = id ? parseInt(id) : 0;

  const defaultAttachmentValues: any = {
    documentLabel: '',
    isRequired: false,
    supportedFileExtensions: [],
    updateAttachments: [],
    documents: []
  };

  const printRef = useRef<any>();
  const { themeVersion, userInfo, updateNotificationCount } = useContext(AppContext);
  const privileges: string[] = userInfo ? userInfo.Privileges.split(',') : [];

  const isDarkTheme = themeVersion === "black" ? true : false;
  const [formValues, setFormValues] = useState<CaseViewModel>({} as CaseViewModel);
  const [oldFormValues, setOldFormValues] = useState<CaseViewModel>({} as CaseViewModel);
  const [wards, setWards] = useState<IdNameViewModel[] | undefined>([]);
  const [neighborhoods, setNeighborhoods] = useState<IdNameViewModel[]>([]);
  const [serverTags, setServerTags] = useState<IdNameBoolViewModel[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isNoteLoading, setIsNoteLoading] = useState<boolean>(false);
  const [isUpdateLoading, setIsUpdateLoading] = useState<boolean>(false);
  const [isHistoryLoading, setIsHistoryLoading] = useState<boolean>(false);
  const [isOtherCaseLoading, setIsOtherCaseLoading] = useState<boolean>(false);
  const [isEditorFocus, setIsEditorFocus] = useState<boolean>(false);
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
  const [emailEditorState, setEmailEditorState] = useState(() => EditorState.createEmpty());
  const [isEmailFocus, setIsEmailFocus] = useState<boolean>(false);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [isShowAllCommunicationNotes, setIsShowAllCommunicationNotes] = useState<boolean>(false);
  const [communicationHistoryAttachments, setCommunicationHistoryAttachments] = useState<UploadDocumentViewModel>(defaultAttachmentValues);
  const [communicationHistoryBody, setCommunicationHistoryBody] = useState<string>();
  const [communicationHistoryTotalCount, setCommunicationHistoryTotalCount] = useState<number>(0);
  const [communicationHistories, setCommunicationHistories] = useState<CommunicationHistoryViewModel[]>([]);
  const [signatureMessage, setSignatureMessage] = useState<string>();
  const [ccEmails, setCcEmails] = useState<any>([]);
  const [selectedCcEmails, setSelectedCcEmails] = useState<any>([]);
  const [maxFileSize, setMaxFileSize] = useState<number>(0);
  const [caseNoteResponse, setCaseNoteResponse] = useState<CaseNoteViewModel>();
  const [isShowAllOtherCases, setIsShowAllOtherCases] = useState<boolean>(false);
  const [otherCases, setOtherCases] = useState<OtherCasesModel[]>([]);
  const [otherCasesCount, setOtherCasesCount] = useState<number>(0);
  const [isNoteFocus, setIsNoteFocus] = useState<boolean>(false);
  const [tagOptions, setTagOptions] = useState<any>([]);
  const [isAllowTagAddition, setIsAllowTagAddition] = useState<boolean>(false);
  const [saveText, setSaveText] = useState<string>('Saved');
  const [fileUploadKey, setFileUploadKey] = useState<string>('file_upload_key');
  const [blobImagesArr, setBlobImagesArr] = useState<any>([]);
  const [isDraftEmailSaving, setIsDraftEmailSaving] = useState<boolean>(false);

  const [formErrors, setFormErrors] = useState<FormErrorFields>({
    constituent: '',
    subject: '',
    caseType: '',
    source: '',
    status: '',
    attachments: ''
  });

  const [historyFormErrors, setHistoryFormErrors] = useState<HistoryFormErrorFields>({
    communicationHistoryBody: ''
  });

  const [noteFormErrors, setNoteFormErrors] = useState<NoteFormErrorFields>({
    notes: ''
  });

  const communicationHistoryCount: number = process.env.REACT_APP_COMMUNICATION_HISTORY_COUNT !== undefined ? parseInt(process.env.REACT_APP_COMMUNICATION_HISTORY_COUNT) : 5;

  useEffect(() => {
    if (caseNumber > 0) {
      document.title = 'Edit Case - Adjure';
    } else {
      document.title = 'Create Case - Adjure';
    }
    fetchData();
  }, [caseNumber]);

  useEffect(() => {
    if (userInfo && userInfo.OfficeId === "1" && caseNumber === 0) {
      navigate('/');
    }
    if (privileges.includes(token_config.MANAGE_TAGS)) {
      setIsAllowTagAddition(true);
    }
  }, [userInfo, caseNumber, navigate]);

  const isHtmlOrPlainText = (showHtml: string) => {
    const htmlRegex = /<([a-z][a-z0-9]*)\b[^>]*>(.*?)<\/\1>/i;
    if (htmlRegex.test(showHtml)) {
      try {
        // Parse the content with DOMParser
        const parser = new DOMParser();
        const doc = parser.parseFromString(showHtml, 'text/html');

        // Check if the document contains valid HTML elements
        const hasValidHTMLElement = Array.from(doc.body.childNodes).some(node => node.nodeType === Node.ELEMENT_NODE);
        if (hasValidHTMLElement) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    }
    return false;
  }

  const fetchData = async () => {
    try {
      setIsLoading(true);
      await axiosInstance.get('/AdminSetting/GetMaxUploadFileSize').then(({ data, status }) => {
        if (status === 200) {
          setMaxFileSize(data);
        }
      })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        });
      let apiUrl = `/Case/GetView`;
      if (caseNumber > 0) {
        apiUrl = `/Case/GetCase/${caseNumber}`;
      }
      await axiosInstance.get(apiUrl).then(async ({ data, status }) => {
        if (status === 200) {
          let caseViewModel = data as CaseViewModel;
          caseViewModel.constituentId = caseViewModel.constituent?.constituentId ? caseViewModel.constituent?.constituentId : 0;
          if (caseNumber === 0) {
            caseViewModel.statusId = (((caseViewModel.masterData?.status || []).find((item) => item.name?.toLowerCase() === 'new'))?.id || null);
            if (userInfo) {
              caseViewModel.assignedToId = parseInt(userInfo.UserId);
            }
          }
          if (caseViewModel.wardId) {
            const wardIndex: any = _.findIndex(caseViewModel.masterData?.wardNeighborhood, { id: caseViewModel.wardId });
            setNeighborhoods((caseViewModel.masterData?.wardNeighborhood[wardIndex] as any).neighborhoods);
            const tmpWards: any = [];
            tmpWards.push(caseViewModel.masterData?.wardNeighborhood[wardIndex]);
            setWards(tmpWards);
          } else {
            const neighborhoods: any = [];
            caseViewModel.masterData?.wardNeighborhood.map((ward: any) => {
              neighborhoods.push(...ward.neighborhoods);
              return true;
            });
            const tmpNeighborhoods: any = _.sortBy(_.uniqBy(neighborhoods, 'id'), 'name');
            setNeighborhoods(tmpNeighborhoods);
            setWards(caseViewModel.masterData?.wardNeighborhood);
          }
          if (caseViewModel.masterData?.tag) {
            setTagOptions(convertToDropDownProps(caseViewModel.masterData?.tag));
          }
          if (caseViewModel.isHighPriority === null) {
            caseViewModel.isHighPriority = false;
          }
          if (caseViewModel.images && caseViewModel.images?.length > 0) {
            const tmpImagesAndDesc = await downloadImagesAndReplace(caseViewModel.images, caseViewModel.description);
            caseViewModel.description = tmpImagesAndDesc.description;
            setBlobImagesArr(tmpImagesAndDesc.blobImagesArr);
          }
          caseViewModel.isHtmlOrPlainText = isHtmlOrPlainText(caseViewModel.description || '');
          setFormValues(caseViewModel);
          setOldFormValues(caseViewModel);
          setServerTags(data.tags);
          if (caseNumber > 0) {
            fetchOtherCases(3, caseViewModel.caseRecordId, caseViewModel.constituentId);
            fetchCommunicationHistory(5, caseViewModel.caseRecordId, caseViewModel.images);
            fetchNotes(caseViewModel.caseRecordId);
          }
        }
        successCount++;
        if (caseNumber === 0 || successCount === 4) {
          setIsLoading(false);
        }
      })
        .catch((error) => {
          navigate('/dashboard');
          setIsLoading(false);
          console.log(error);
        });
    } catch (error: any) {
      setIsLoading(false);
      console.log(error);
    }
  }

  const fetchCommunicationHistory = (communicationHistoryCount: any, caseRecordId: number, images: CaseImageViewModel[] | null) => {
    let apiUrl = `/Case/GetCommunicationHistory/${caseRecordId}`;
    if (communicationHistoryCount) {
      apiUrl += `/${communicationHistoryCount}`;
    }
    axiosInstance.get(apiUrl).then(async ({ data, status }) => {
      if (status === 200) {
        await Promise.all(
          data.communicationHistory.map(async (tmpCommunicationHistory: CommunicationHistoryViewModel, tmpCommunicationHistoryIndex: number) => {
            if (images && images?.length > 0) {
              const tmpImagesAndDesc = await downloadImagesAndReplace(images, tmpCommunicationHistory.body);
              tmpCommunicationHistory.body = tmpImagesAndDesc.description;
            }
            data.communicationHistory[tmpCommunicationHistoryIndex].isHtmlOrPlainText = isHtmlOrPlainText(tmpCommunicationHistory.body);
          })
        );
        setSignatureMessage(data.signatureMessage === null ? '' : data.signatureMessage);
        setCommunicationHistoryTotalCount(data.totalCount);
        setCommunicationHistories(data.communicationHistory);
        if (communicationHistoryCount === 0) {
          setIsShowAllCommunicationNotes(true);
        }
        draftEmail = data.draftEmail;
        oldDraftEmail = _.cloneDeep(data.draftEmail);
        if (draftEmail && draftEmail.caseRecordDraftEmailHistoryId > 0) {
          const contentState = stateFromHTML(draftEmail.body !== null ? draftEmail.body : ('<br/>' + signatureMessage || ''));
          const newEditorState = EditorState.createWithContent(contentState);
          setEmailEditorState(newEditorState);
          let tmpSelectedCcEmails: any = [];
          draftEmail.ccEmailIds.map((ccEmail) => {
            tmpSelectedCcEmails.push(ccEmail.email);
          });
          setCcEmails(tmpSelectedCcEmails);
          setSelectedCcEmails(tmpSelectedCcEmails);
        } else {
          draftEmail = {
            caseRecordId: 0,
            caseRecordEmailHistoryId: 0,
            caseRecordDraftEmailHistoryId: 0,
            name: '',
            body: '',
            createdDate: '',
            nameColorCode: '',
            attachments: {
              documentLabel: '',
              isRequired: false,
              supportedFileExtensions: '',
              updateAttachments: [],
              documents: [],
            },
            isHtmlOrPlainText: false,
            ccEmailIds: [],
            isUpdated: 0,
          }
          let tmpCcEmails: any = [];
          if (data.distinctCCEmailIds.length > 0) {
            data.distinctCCEmailIds.map((ccEmail: any) => {
              tmpCcEmails.push(ccEmail.email);
            });
            setCcEmails(tmpCcEmails);
          }
          let tmpSelectedCcEmails: any = [];
          if (data.communicationHistory.length > 0) {
            data.communicationHistory[data.communicationHistory.length - 1].ccEmailIds.map((ccEmail: any) => {
              tmpSelectedCcEmails.push(ccEmail.email);
            });
            setSelectedCcEmails(tmpSelectedCcEmails);
          }
        }
      }
      successCount++;
      if (successCount === 4) {
        setIsLoading(false);
      }
      clearInterval(draftIntervalId);
      setIsEmailFocus(false);
      setIsHistoryLoading(false);
    })
      .catch((error) => {
        setIsLoading(false);
        setIsHistoryLoading(false);
        console.log(error);
      });
  }

  const fetchOtherCases = (otherCaseCount: any, caseRecordId: number, constituentId: number) => {
    let apiUrl = `/Case/GetOtherCases/${caseRecordId}/${constituentId}`;
    if (otherCaseCount) {
      apiUrl += `/${otherCaseCount}`;
    }
    axiosInstance.get(apiUrl).then(({ data, status }) => {
      if (status === 200 || status === 204) {
        setOtherCasesCount(data.totalCount);
        setOtherCases(data.otherCases);
        if (otherCaseCount === 0) {
          setIsShowAllOtherCases(true);
        }
      }
      successCount++;
      if (successCount === 4) {
        setIsLoading(false);
      }
      setIsOtherCaseLoading(false);
    })
      .catch((error) => {
        setIsLoading(false);
        setIsOtherCaseLoading(false);
        console.log(error);
      });
  }

  const fetchNotes = (caseRecordId: number) => {
    axiosInstance.get(`/Case/GetCaseRecordNotes/${caseRecordId}`).then(({ data, status }) => {
      if (status === 200) {
        setCaseNoteResponse(data);
      }
      successCount++;
      if (successCount === 4) {
        setIsLoading(false);
      }
      setIsNoteLoading(false);
    })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  }

  const fetchNotificationCount = async () => {
    try {
      await axiosInstance.get(`/Dashboard/GetNotificationCount`).then(({ data, status }) => {
        if (status === 200) {
          updateNotificationCount(data);
        }
      })
        .catch((error: any) => {
          console.log(error);
        });
    } catch (error: any) {
      console.log(error);
    }
  }

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
    setSaveText(_.isEqual(oldFormValues, { ...formValues, [name]: value }) ? 'Saved' : 'Unsaved');
  };

  const handleTextAreaChange = (event: React.ChangeEvent<HTMLTextAreaElement>, data: TextAreaProps) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
    setSaveText(_.isEqual(oldFormValues, { ...formValues, [name]: value }) ? 'Saved' : 'Unsaved');
  };

  const handleDateChange = (date: any, field: any) => {
    const selectedDate = date.value ? new Date(date.value) : undefined;
    setFormValues({ ...formValues, [field]: selectedDate });
  };

  const handleDropdownChange = (event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
    const { name, value } = data;
    const tmpValue = value === "" ? null : value;
    if (name === 'neighborhoodId' && formValues.wardId === null) {
      const tmpWards: any = [];
      masterData?.wardNeighborhood.map((ward: any) => {
        const wardIndex = _.findIndex(ward.neighborhoods, { id: tmpValue });
        if (wardIndex !== -1) {
          tmpWards.push(ward);
        }
        return true;
      });
      setWards(tmpWards);
      if (tmpWards.length === 1) {
        setFormValues({ ...formValues, [name]: tmpValue, wardId: tmpWards[0].id });
        setSaveText(_.isEqual(oldFormValues, { ...formValues, [name]: tmpValue, wardId: tmpWards[0].id }) ? 'Saved' : 'Unsaved');
        const wardIndex: any = _.findIndex(masterData?.wardNeighborhood, { id: tmpWards[0].id });
        setNeighborhoods((masterData?.wardNeighborhood[wardIndex] as any).neighborhoods);
      } else {
        setFormValues({ ...formValues, [name]: tmpValue });
        setSaveText(_.isEqual(oldFormValues, { ...formValues, [name]: tmpValue }) ? 'Saved' : 'Unsaved');
      }
    } else {
      if (name === 'wardId') {
        if (typeof tmpValue === 'number') {
          if (tmpValue === 14) {
            setFormValues({ ...formValues, [name]: tmpValue, neighborhoodId: 93 });
          } else {
            setFormValues({ ...formValues, [name]: tmpValue });
          }
          setSaveText(_.isEqual(oldFormValues, { ...formValues, [name]: tmpValue }) ? 'Saved' : 'Unsaved');
          const wardIndex: any = _.findIndex(masterData?.wardNeighborhood, { id: tmpValue });
          setNeighborhoods((masterData?.wardNeighborhood[wardIndex] as any).neighborhoods);
        } else {
          setFormValues({ ...formValues, [name]: tmpValue, neighborhoodId: null });
          setSaveText(_.isEqual(oldFormValues, { ...formValues, [name]: tmpValue, neighborhoodId: null }) ? 'Saved' : 'Unsaved');
          const neighborhoods: any = [];
          masterData?.wardNeighborhood.map((ward: any) => {
            neighborhoods.push(...ward.neighborhoods);
            return true;
          });
          const tmpNeighborhoods: any = _.sortBy(_.uniqBy(neighborhoods, 'id'), 'name');
          setNeighborhoods(tmpNeighborhoods);
          setWards(masterData?.wardNeighborhood);
        }
      } else {
        setFormValues({ ...formValues, [name]: tmpValue });
        setSaveText(_.isEqual(oldFormValues, { ...formValues, [name]: tmpValue }) ? 'Saved' : 'Unsaved');
      }
    }
  };

  const handleDropdownBlur = (event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
    const { name, value } = data;
    validate(false, name, value);
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    validate(false, name, value);
  };

  const onAddConstituent = (constituent: ConstituentViewModel) => {
    setFormValues({ ...formValues, constituent, constituentId: constituent.constituentId });
    setSaveText(_.isEqual(oldFormValues, { ...formValues, constituent, constituentId: constituent.constituentId }) ? 'Saved' : 'Unsaved');
    setIsOpenModal(false);
  }

  const handleAttachmentsChange = (updateFiles: AttachmentChangeViewModel, removeNewFile: Boolean = false) => {
    setFormValues((prevFiles) => {
      let updateAttachments = [...prevFiles.attachments?.updateAttachments] as AttachmentChangeViewModel[];
      if (removeNewFile) {
        updateAttachments = updateAttachments.filter((f) => f.attachmentGUID !== updateFiles.attachmentGUID);
      } else {
        updateAttachments.push({ ...updateFiles });
      }
      return { ...prevFiles, attachments: { ...prevFiles.attachments, updateAttachments: updateAttachments } }
    });
    setSaveText('Unsaved');
  }

  const handleCommunicationAttachmentsChange = (updateFiles: AttachmentChangeViewModel, removeNewFile: Boolean = false) => {
    setCommunicationHistoryAttachments((prevFiles) => {
      let updateAttachments = [...prevFiles.updateAttachments] as AttachmentChangeViewModel[];
      if (removeNewFile) {
        updateAttachments = updateAttachments.filter((f) => f.attachmentGUID !== updateFiles.attachmentGUID);
      } else {
        updateAttachments.push({ ...updateFiles });
      }
      return { ...prevFiles, updateAttachments: updateAttachments }
    });
    if (draftEmail.isUpdated === undefined) {
      draftEmail.isUpdated = 0;
    }
    draftEmail.isUpdated++;
  }

  const onHandleAddition = (e: React.SyntheticEvent<HTMLElement, Event>, dropdownProps: DropdownProps) => {
    const { value } = dropdownProps;
    if (typeof value === 'string') {
      setTagOptions([{ text: value, value }, ...tagOptions]);
    }
  }

  const onHandleMuliSelect = (event: React.SyntheticEvent<HTMLElement>, dropdownProps: DropdownProps) => {
    const { value } = dropdownProps;
    let tempTags: IdNameBoolViewModel[] = [] as IdNameBoolViewModel[];
    if (typeof value === 'object') {
      value.map((tmpValue: any) => {
        if (typeof tmpValue === 'number') {
          const tagIndex = _.findIndex((masterData?.tag || []), { id: tmpValue });
          tempTags.push({ isMarkedForDelete: false, id: masterData?.tag[tagIndex].id, name: masterData?.tag[tagIndex].name } as IdNameBoolViewModel);
        } else {
          tempTags.push({ isMarkedForDelete: false, id: 0, name: tmpValue } as IdNameBoolViewModel);
        }
      });
      const existingIDs: number[] = _.map(serverTags, 'id');
      const deletedIds = _.difference(existingIDs, value);
      deletedIds.map((deletedId: any) => {
        const tagIndex = _.findIndex((masterData?.tag || []), { id: deletedId });
        tempTags.push({ isMarkedForDelete: true, id: masterData?.tag[tagIndex].id, name: masterData?.tag[tagIndex].name } as IdNameBoolViewModel);
      });
      setFormValues({ ...formValues, tags: tempTags });
      setSaveText(_.isEqual(oldFormValues, { ...formValues, tags: tempTags }) ? 'Saved' : 'Unsaved');
    }
  }

  const handleRichEditorChange = (newEditorState: EditorState) => {
    setEditorState(newEditorState);

    const currentContent = newEditorState.getCurrentContent();
    const plainText = stateToHTML(currentContent);
    // Update the form field value
    setFormValues(currentFormValues => {
      const updatedFormValues = { ...currentFormValues, description: plainText };
      if (oldFormValues.caseRecordId > 0) {
        setSaveText(_.isEqual(oldFormValues, updatedFormValues) ? 'Saved' : 'Unsaved');
      }
      return updatedFormValues;
    });
  };

  const handleRichEditorFocus = () => {
    if (!isEditorFocus) {
      const tmpDescription = formValues.isHtmlOrPlainText ? (formValues.description || '') : (formValues.description || '').split('\n').join('<br/>');
      // Convert the plain text content to EditorState and update the RichTextEditor
      const blocksFromHTML = convertFromHTML(tmpDescription);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      const newEditorState = EditorState.createWithContent(contentState, decoratorPlugin());
      setEditorState(newEditorState);
    }
    setIsEditorFocus(true);
  };

  const handleRichEmailEditorChange = (newEditorState: EditorState, isBlur: boolean | undefined) => {
    // Apply your decorator plugin to the editorState
    const newEditorStateWithLink = EditorState.set(newEditorState, { decorator: decoratorPlugin() });
    setEmailEditorState(newEditorStateWithLink);
    const currentContent = newEditorStateWithLink.getCurrentContent();
    const plainText = stateToHTML(currentContent);
    setCommunicationHistoryBody(plainText);
    draftEmail.body = plainText;
  };

  const handleRichEmailEditorFocus = () => {
    if (!isEmailFocus) {
      // Convert the plain text content to EditorState and update the RichTextEditor
      const contentState = stateFromHTML(draftEmail.body !== '<p><br></p>' ? draftEmail.body : ('<br/>' + signatureMessage || ''));
      const newEditorState = EditorState.createWithContent(contentState);
      setEmailEditorState(newEditorState);
    }
    clearInterval(draftIntervalId);
    draftIntervalId = setInterval(() => {
      // Save draft
      saveCommunicationHistory();
    }, parseInt(String(saveDraftEmailSeconds), 10) * 1000);
    setIsEmailFocus(true);
  };

  const handleRichEmailEditorBlur = () => {
    clearInterval(draftIntervalId);
    draftEmail.body = '';
    setEmailEditorState(EditorState.createEmpty());
    setIsEmailFocus(false);
    setHistoryFormErrors({} as HistoryFormErrorFields);
  };

  const validate = async (validateAll: boolean, fieldName: string | null = null, value: any | null = null): Promise<FormErrorFields> => {
    return await new Promise((resolve, reject) => {
      let errors: FormErrorFields = { ...formErrors };
      try {
        if (validateAll) {
          errors = {
            subject: !formValues?.subject ? 'Subject is required' : '',
            constituent: !formValues?.constituentId ? 'Constituent is required' : '',
            caseType: !formValues?.caseTypeId ? 'Case type is required' : '',
            source: !formValues?.sourceId ? 'Source is required' : '',
            status: !formValues?.statusId ? 'Status is required' : '',
            attachments: (formValues?.attachments.isRequired && formValues?.attachments?.documents.length === 0) ? 'Attachments is required' : '',
          };
        } else {
          switch (fieldName) {
            case 'subject':
              errors.subject = !value ? 'Subject is required' : '';
              break;
            case 'constituent':
              errors.constituent = !value ? 'Constituent is required' : '';
              break;
            case 'caseTypeId':
              errors.caseType = !value ? 'Case Type is required' : '';
              break;
            case 'sourceId':
              errors.source = !value ? 'Source is required' : '';
              break;
            case 'statusId':
              errors.status = !value ? 'Status is required' : '';
              break;
            default:
              break;
          }
        }
        setFormErrors(errors);
        resolve(errors);
      } catch (error) {
        console.log(`Validation error`);
        reject(errors);
      }
    });
  }

  useEffect(() => {
    function setUnsaveAlert() {
      if (saveText === 'Unsaved') {
        return Swal.fire({
          title: 'Changes you have made may not be saved',
          icon: 'warning',
          confirmButtonText: 'Save',
          denyButtonText: 'Cancel',
          showDenyButton: true,
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            handleSubmit();
            return false;
          } else {
            return true;
          }
        });
      } else {
        return true;
      }
    }
    setCallUnsaveAlert(setUnsaveAlert);
  }, [formValues]);

  const handleCancel = () => {
    if (saveText === 'Unsaved') {
      Swal.fire({
        title: 'Changes you have made may not be saved',
        icon: 'warning',
        confirmButtonText: 'Save',
        denyButtonText: 'Cancel',
        showDenyButton: true,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          handleSubmit();
        } else {
          navigate('/dashboard');
        }
      });
    } else {
      navigate('/dashboard');
    }
  }

  const handleSubmit = async () => {
    setIsUpdateLoading(true);
    setSaveText('Saving');
    const errors = await validate(true);
    const hasErrors = Object.values(errors).some((error) => error);
    if (!hasErrors) {
      // handle form submission 
      let payLoad = { ...formValues };
      payLoad.masterData = null;
      payLoad.subject = payLoad.subject.trim();
      if (Object.keys(blobImagesArr).length > 0) {
        // Create a new object by swapping keys and values
        const swappedArr = Object.fromEntries(
          Object.entries(blobImagesArr).map(([key, value]) => [value, key])
        );
        payLoad.description = strtr(payLoad.description, swappedArr);
      }
      await axiosInstance.post(`/Case/AddUpdateCase`, payLoad).then(async ({ data, status }) => {
        if (status === 200) {
          setSaveText('Saved');
          if (caseNumber > 0) {
            fetchNotificationCount();
            fetchCommunicationHistory(5, payLoad.caseRecordId, formValues.images);
            await axiosInstance.get(`/Case/GetCase/${caseNumber}`).then((tmpResponse) => {
              if (tmpResponse.status === 200) {
                setFormValues({ ...formValues, subject: payLoad.subject, attachments: tmpResponse.data.attachments });
                setFileUploadKey('file_upload_key_updated');
              }
            });
          }
          if (payLoad.caseRecordId === 0) {
            let returnCaseInfo = data as CaseRecordSuccessViewModel;
            Swal.fire({
              title: 'Case created successfully',
              icon: 'success',
              html: `<div class="form-custom" style="text-align: left">
                    <div class="ui relaxed divided list">
                    <div class="item"><strong>Case number</strong>&nbsp;&nbsp;<span>${returnCaseInfo.caseNumber || ''}</span></div>
                    <div class="item"><strong>Title</strong><p>${returnCaseInfo.title || ''}</p></div>
                    <div class="item"><strong>Constituent</strong><p>${returnCaseInfo.constituent.constituentName || ''} <br/>
                    ${returnCaseInfo.constituent.address || ''} <br/>
                    ${`${returnCaseInfo.constituent.neighborhood ? `${returnCaseInfo.constituent.neighborhood}, ` : ''}`}${returnCaseInfo.constituent.ward || ''}  </p>
                    </div></div></div>`,
              confirmButtonText: 'Cases Dashboard',
              showConfirmButton: true,
              showDenyButton: true,
              denyButtonText: 'Edit Case',
              denyButtonColor: '#657193',
              allowOutsideClick: false,
              allowEscapeKey: false
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = '/dashboard';
              } else if (result.isDenied) {
                window.location.href = `/case/${returnCaseInfo.caseNumber}`;
              }
            });
          }
        }
        setIsUpdateLoading(false);
      });
    } else {
      setIsUpdateLoading(false);
      console.log('No valid!');
    }
  };

  const validateHistory = async (): Promise<HistoryFormErrorFields> => {
    return await new Promise((resolve, reject) => {
      let errors: HistoryFormErrorFields = { ...historyFormErrors };
      try {
        errors = {
          communicationHistoryBody: !communicationHistoryBody?.replace(/(<([^>]+)>)/gi, "") ? 'Required' : '',
        };
        setHistoryFormErrors(errors);
        resolve(errors);
      } catch (error) {
        console.log(`Validation error`);
        reject(errors);
      }
    });
  }

  const handleCommunicationHistorySubmit = async () => {
    setIsHistoryLoading(true);
    const errors = await validateHistory();
    const hasErrors = Object.values(errors).some((error) => error);
    if (!hasErrors) {
      // Closed status
      if (formValues.statusId === 4) {
        Swal.fire({
          icon: "warning",
          text: 'This case is closed.  Do you still want to send a message?',
          confirmButtonText: 'Continue',
          showConfirmButton: true,
          showDenyButton: true,
          denyButtonText: 'Cancel',
          denyButtonColor: '#657193'
        }).then((result) => {
          if (result.isConfirmed) {
            postCommunicationHistory();
            // Change status to in-progress
            setFormValues({ ...formValues, statusId: 2 });
          } else {
            setIsHistoryLoading(false);
            handleRichEmailEditorBlur();
          }
        });
      } else {
        postCommunicationHistory();
      }
    } else {
      setIsHistoryLoading(false);
      console.log('No valid!');
    }
  };

  const saveCommunicationHistory = async () => {
    if (!_.isEqual(oldDraftEmail, draftEmail)) {
      setIsDraftEmailSaving(true);
      // handle form submission 
      let payload: any = {
        caseRecordId: formValues.caseRecordId,
        body: draftEmail.body,
        attachments: communicationHistoryAttachments.updateAttachments.length > 0 ? communicationHistoryAttachments : null,
      };
      if (selectedCcEmails.length > 0) {
        payload.ccEmailIds = [];
        selectedCcEmails.map((selectedCcEmail: string) => {
          payload.ccEmailIds.push({
            email: selectedCcEmail.trim()
          });
        });
      }
      payload.caseRecordDraftEmailHistoryId = draftEmail.caseRecordDraftEmailHistoryId;
      await axiosInstance.post('Case/SaveDraftCommunicationHistory', payload).then(({ data, status }) => {
        if (status === 200) {
          draftEmail = data;
          oldDraftEmail = _.cloneDeep(data);
          setCommunicationHistoryAttachments(defaultAttachmentValues);
        }
        setIsDraftEmailSaving(false);
      })
        .catch((error) => {
          setIsDraftEmailSaving(false);
          console.log(error);
        });
    }
  }

  const postCommunicationHistory = async () => {
    // handle form submission 
    let payload: any = {
      caseRecordId: formValues.caseRecordId,
      body: communicationHistoryBody,
      attachments: communicationHistoryAttachments.updateAttachments.length > 0 ? communicationHistoryAttachments : null,
    };
    if (selectedCcEmails.length > 0) {
      payload.ccEmailIds = [];
      selectedCcEmails.map((selectedCcEmail: string) => {
        payload.ccEmailIds.push({
          email: selectedCcEmail.trim()
        });
      });
    }
    payload.caseRecordDraftEmailHistoryId = draftEmail.caseRecordDraftEmailHistoryId;
    await axiosInstance.post('Case/AddCommunicationHistory', payload).then(({ data, status }) => {
      if (status === 200) {
        clearInterval(draftIntervalId);
        draftEmail = data.draftEmail;
        oldDraftEmail = _.cloneDeep(data.draftEmail);
        setEmailEditorState(EditorState.createEmpty());
        setCommunicationHistoryAttachments(defaultAttachmentValues);
        fetchCommunicationHistory(isShowAllCommunicationNotes ? 0 : communicationHistoryCount, formValues.caseRecordId, formValues.images);
      } else {
        setIsHistoryLoading(false);
      }
    })
      .catch((error) => {
        setIsHistoryLoading(false);
        console.log(error);
      });
  }

  const validateNote = async (): Promise<NoteFormErrorFields> => {
    return await new Promise((resolve, reject) => {
      let errors: NoteFormErrorFields = { ...noteFormErrors };
      try {
        errors = {
          notes: !formValues.notes ? 'Required' : '',
        };
        setNoteFormErrors(errors);
        resolve(errors);
      } catch (error) {
        console.log(`Validation error`);
        reject(errors);
      }
    });
  }

  const handleNoteSubmit = async () => {
    setIsNoteLoading(true);
    const errors = await validateNote();
    const hasErrors = Object.values(errors).some((error) => error);
    if (!hasErrors) {
      // handle form submission 
      let payload = {
        caseRecordId: formValues.caseRecordId,
        note: formValues.notes
      };
      await axiosInstance.post('Case/AddUpdateCaseRecordNote', payload).then(({ data, status }) => {
        if (status === 200) {
          setIsNoteFocus(false);
          setFormValues({ ...formValues, notes: '' });
          fetchNotes(formValues.caseRecordId);
        } else {
          setIsNoteLoading(false);
        }
      })
        .catch((error) => {
          setIsNoteLoading(false);
          console.log(error);
        });
    } else {
      setIsNoteLoading(false);
      console.log('No valid!');
    }
  };

  const handleDelete = () => {
    const apiUrl = `/Case/DeleteCase/${caseNumber}`;
    const options: SweetAlertOptions = {
      title: 'Are you sure you want to delete?',
      text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
    };
    Swal.fire(options).then((result) => {
      if (result.isConfirmed) {
        axiosInstance.post(apiUrl, null).then(({ status }) => {
          if (status === 200) {
            toast.success('Case deleted successfully');
            navigate('/dashboard');
          }
        });
      }
    });
  };

  const convertToDropDownProps = (MasterItems: Array<IdNameViewModel>) => {
    return (MasterItems || []).map((item: IdNameViewModel) => ({
      key: item.id,
      text: item.name,
      value: item?.id,
    } as DropdownItemProps));
  }

  const extractTagIds = (items: IdNameBoolViewModel[]) => {
    return items.map(item => item.id);
  };

  const { masterData, attachments } = formValues;
  const tagIds: number[] = extractTagIds(serverTags || []);
  let withoutMasterData = { ...formValues };
  withoutMasterData.masterData = null;

  const replaceFontSize = (fontSize: string) => {
    if (document.getElementsByClassName('replace-font-size').length > 0) {
      const replaceFontSizeRow = document.getElementsByClassName('replace-font-size').length;
      for (let i = 0; i < replaceFontSizeRow; i++) {
        const elements = document.getElementsByClassName('replace-font-size')[i].querySelectorAll('*');
        for (let j = 0; j < elements.length; ++j) {
          const styleAttr = (elements[j] as any).getAttribute('style');
          if (styleAttr && styleAttr.indexOf('font-size') !== -1) {
            (elements[j] as any).style.fontSize = fontSize;
          }
        }
      }
    }
  }

  const beforePrint = () => {
    // Fix for font-size coming from Outlook
    replaceFontSize('12pt');
  }

  const afterPrint = () => {
    // Revert the fix for font-size coming from Outlook
    replaceFontSize('11pt');
  }

  const statusIcon = (status: string) => {
    switch (status) {
      case 'New': {
        return <Popup content={status} trigger={<span className="btn-round"><ReactSVG src={onNewFileIcons} /></span>} />
      }
      case 'In-progress': {
        return <Popup content={status} trigger={<span className="btn-round"><ReactSVG src={onProgressIcons} /></span>} />
      }
      case 'Awaiting Info': {
        return <Popup content={status} trigger={<span className="btn-round"><ReactSVG src={onAwaitingInfo} /></span>} />
      }
      case 'Completed': {
        return <Popup content={status} trigger={<span className="btn-round"><ReactSVG src={onCompletedIcons} /></span>} />
      }
      case 'Closed': {
        return <Popup content={status} trigger={<span className="btn-round"><ReactSVG src={onClosedIcons} /></span>} />
      }
      default: {
        return null;
      }
    }
  }

  return (
    <section className="section" style={{
      minHeight: '100vh'
    }}>
      <div className="section__head">
        <div className="section__head-content">
          <Header as="h1">
            {caseNumber === 0 ? 'Create' : 'Edit'} Case
          </Header>
        </div>
        <div className="section__actions">
          <UserInfo />
          <SwitchTheme />
        </div>
      </div>
      <div className='section__body'>
        <Dimmer.Dimmable as="div" dimmed={isLoading}>
          <Dimmer active={isLoading} inverted={true}>
            <Loader>Loading</Loader>
          </Dimmer>
          <Grid>
            <Grid.Row>
              {caseNumber > 0 && (
                <>
                  <Grid.Column width={16}>
                    <div style={{ float: 'right', fontSize: '1.5rem', color: 'grey' }}>{saveText}</div>
                  </Grid.Column>
                  <Grid.Column width={16}>
                    <Button type="submit" onClick={handleSubmit} className='violet right floated button' style={{ padding: '1.1rem 2.1rem', borderRadius: '0rem' }}>Save</Button>
                    <Button type="button" className='second right floated button' style={{ padding: '1.1rem 2.1rem', borderRadius: '0rem', color: 'white' }} onClick={handleCancel}>Cancel</Button>
                    <ReactToPrint
                      trigger={() => <Button type="button" className='violet right floated button' style={{ padding: '1.1rem 2.1rem', borderRadius: '0rem', backgroundColor: '#CAECF4', color: '#000000ab' }}> Print <Icon name="print" style={{ paddingBottom: '1.8rem' }} /></Button>}
                      content={() => printRef.current}
                      onBeforePrint={() => beforePrint()}
                      onAfterPrint={() => afterPrint()}
                    />
                  </Grid.Column>
                </>
              )}
              <Grid.Column mobile={16} tablet={16} computer={caseNumber > 0 ? 9 : 16}>
                <Form className='form-custom'>
                  <Dimmer.Dimmable as="div" dimmed={isUpdateLoading}>
                    <Dimmer active={isUpdateLoading} inverted={true}>
                      <Loader>Loading</Loader>
                    </Dimmer>
                    <Form.Group style={{ marginBottom: formValues?.constituent?.constituentId ? '0.3em' : '1em' }}>
                      <Form.Field width='15' required style={{ position: 'relative' }}>
                        <label>Constituent</label>
                        <ConstituentAutoComplete
                          key={'Constituent'}
                          apiEndpoint={`/case/GetConstituents`}
                          param={{ officeId: 1 }}
                          onHandleChange={(value: ConstituentViewModel) => {
                            setFormValues({ ...formValues, constituent: value, constituentId: value.constituentId });
                            setSaveText(_.isEqual(oldFormValues, { ...formValues, constituent: value, constituentId: value.constituentId }) ? 'Saved' : 'Unsaved');
                          }}
                          onHandleBlur={handleBlur}
                          defaultValue={formValues?.constituent?.constituentName}
                          addNewConstituent={setIsOpenModal}
                        />
                        <Modal
                          onClose={() => setIsOpenModal(false)}
                          onOpen={() => setIsOpenModal(true)}
                          open={isOpenModal}
                          className={themeVersion === 'black' ? 'dark-theme' : ''}
                        >
                          <Modal.Header>
                            <span>{formValues?.constituent?.constituentId ? 'Edit Constituent' : 'Add New Constituent'}</span>
                            <span><Icon name="close" style={{ float: "right", cursor: "pointer" }} onClick={() => setIsOpenModal(false)} /></span>
                          </Modal.Header>
                          <Modal.Content>
                            <ConstituentForm isModal onAddConstituent={onAddConstituent} handleModalCancel={setIsOpenModal} modalConstituentId={formValues?.constituent?.constituentId} />
                          </Modal.Content>
                        </Modal>
                        {formErrors?.constituent && <div className="error-message" style={{ color: 'red' }}>{formErrors?.constituent}</div>}
                      </Form.Field>
                      {formValues?.constituent?.constituentId &&
                        <Form.Field width='1'>
                          <label style={{ marginBottom: '0px' }}>&nbsp;</label>
                          <Icon name='edit' size='large' style={{ marginTop: '0.4em', cursor: 'pointer' }} onClick={() => setIsOpenModal(true)} />
                        </Form.Field>
                      }
                    </Form.Group>
                    <Form.Group widths='equal'>
                      {formValues?.constituent?.constituentId && (formValues?.constituent?.address || formValues?.constituent?.phoneNumber || formValues?.constituent?.email) &&
                        <Form.Field>
                          <section color='#a3a' className='constituentSection' style={{ padding: '3px 3px 3px 6px', height: formValues?.constituent?.pronouns ? '64px' : '44px' }}>
                            {formValues?.constituent?.pronouns && <p style={{ margin: 0, fontSize: '1.3rem' }}><Icon name="comment" /> {formValues?.constituent?.pronouns}</p>}
                            {formValues?.constituent?.address && <p style={{ margin: 0, fontSize: '1.3rem' }}> <Icon name='map marker alternate' /> {formValues?.constituent?.address} </p>}
                            <p style={{ margin: 0, fontSize: '1.3rem', marginTop: formValues?.constituent?.address ? 0 : '9px' }}>
                              {formValues?.constituent?.phoneNumber && <span><Icon name="phone" /> {formValues?.constituent?.phoneNumber} </span>}
                              {formValues?.constituent?.email && <span><Icon name="mail" /> {formValues?.constituent?.email}</span>}
                            </p>
                          </section>
                        </Form.Field>
                      }
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <Form.Field>
                        <Form.Input
                          label="Subject"
                          name="subject"
                          value={formValues.subject}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                          error={!!formErrors?.subject}
                          required
                          maxLength={255}
                        />
                        {formValues.subject?.length === 255 && <div className="error-message" style={{ color: 'red' }}>Maximum character limit exceeded</div>}
                        {formErrors?.subject && <div className="error-message" style={{ color: 'red' }}>{formErrors?.subject}</div>}
                      </Form.Field>
                      <Form.Field width={2}>
                        <label>&nbsp;</label>
                        <Button type="button"
                          className='right floated'
                          onClick={() => {
                            setSaveText(_.isEqual(oldFormValues, { ...formValues, isHighPriority: !formValues?.isHighPriority }) ? 'Saved' : 'Unsaved');
                            setFormValues((prev) => { return { ...prev, 'isHighPriority': !prev?.isHighPriority } });
                          }}
                          size="huge" circular style={{ padding: '1em', marginTop: '-5px', backgroundColor: formValues?.isHighPriority === true ? '#d95342' : '' }}>
                          <Image src={formValues?.isHighPriority === true ? ExclamationActiveIcon : ExclamationIcon} />
                        </Button>
                      </Form.Field>
                    </Form.Group>
                    <div className='field'>
                      <label>Case Description</label>
                      <RichTextEditor onFocus={handleRichEditorFocus} isFocus={isEditorFocus} onChange={handleRichEditorChange} editorState={editorState} rows={6} theme={isDarkTheme ? 'dark' : 'light'} showHtml={formValues.description} isHtmlOrPlainText={formValues.isHtmlOrPlainText} />
                    </div>
                    <Form.Group widths='equal'>
                      <Form.Field>
                        <div className='field required'>
                          <label>Status</label>
                          <Dropdown
                            name="statusId"
                            options={convertToDropDownProps(masterData?.status || [])}
                            fluid
                            selection
                            clearable
                            value={formValues.statusId ? formValues.statusId : ''}
                            onChange={handleDropdownChange}
                            onBlur={handleDropdownBlur}
                            error={!!formErrors?.status}
                            required
                          />
                          {formErrors?.status && <span style={{ color: 'red' }}>{formErrors?.status}</span>}
                        </div>
                      </Form.Field>
                      <Form.Field>
                        <div className='field'>
                          <label>Assign to</label>
                          <Dropdown
                            name="assignedToId"
                            options={convertToDropDownProps(masterData?.assignTo || [])}
                            fluid
                            selection
                            value={formValues.assignedToId ? formValues.assignedToId : 0}
                            onChange={handleDropdownChange}
                            onBlur={handleDropdownBlur}
                          />
                        </div>
                      </Form.Field>
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <Form.Field>
                        <div className='field required'>
                          <label>Case type</label>
                          <Dropdown
                            name="caseTypeId"
                            options={convertToDropDownProps(masterData?.caseType || [])}
                            fluid
                            selection
                            clearable
                            value={formValues.caseTypeId ? formValues.caseTypeId : ''}
                            onChange={handleDropdownChange}
                            onBlur={handleDropdownBlur}
                            error={!!formErrors?.caseType}
                            required
                          />
                          {formErrors?.caseType && <span style={{ color: 'red' }}>{formErrors?.caseType}</span>}
                        </div>
                      </Form.Field>
                      <Form.Field>
                        <div className='field required'>
                          <label>Source</label>
                          <Dropdown
                            name="sourceId"
                            options={convertToDropDownProps(masterData?.source || [])}
                            fluid
                            selection
                            clearable
                            value={formValues.sourceId ? formValues.sourceId : ''}
                            onChange={handleDropdownChange}
                            onBlur={handleDropdownBlur}
                            error={!!formErrors?.source}
                            required
                          />
                          {formErrors?.source && <span style={{ color: 'red' }}>{formErrors?.source}</span>}
                        </div>
                      </Form.Field>
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <Form.Field>
                        <div className='field'>
                          <label>Ward</label>
                          <Dropdown
                            name="wardId"
                            options={convertToDropDownProps(wards || [])}
                            fluid
                            selection
                            clearable
                            value={formValues.wardId ? formValues.wardId : ''}
                            onChange={handleDropdownChange}
                            onBlur={handleDropdownBlur}
                          />
                        </div>
                      </Form.Field>
                      <Form.Field>
                        <div className='field'>
                          <label>Neighborhood</label>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Dropdown
                              name="neighborhoodId"
                              options={convertToDropDownProps(neighborhoods || [])}
                              fluid
                              selection
                              clearable
                              value={formValues.neighborhoodId ? formValues.neighborhoodId : ''}
                              onChange={handleDropdownChange}
                              onBlur={handleDropdownBlur}
                            />
                            <a className='button primary' rel="noreferrer"
                              style={{ marginLeft: 5, padding: "10px 5px", textDecoration: 'none' }}
                              href='http://apps.ci.minneapolis.mn.us/AddressPortalApp/Search?AppID=PIApp' target='_blank'>
                              <Icon name='external alternate' size='large' style={{ marginLeft: '3px' }} />
                            </a>
                          </div>
                        </div>
                      </Form.Field>
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <Form.Field>
                        <div className='field'>
                          <label>Tag(s)</label>
                          {masterData && masterData.tag &&
                            <Dropdown
                              fluid
                              multiple
                              search
                              selection
                              clearable
                              allowAdditions={isAllowTagAddition ? true : false}
                              additionLabel='Click here to add '
                              options={tagOptions}
                              onChange={onHandleMuliSelect}
                              onAddItem={onHandleAddition}
                              defaultValue={tagIds}
                            />
                          }
                        </div>
                      </Form.Field>
                      <Form.Field>
                        <div className='field'>
                          <label>Department</label>
                          <Dropdown
                            name="departmentId"
                            options={convertToDropDownProps(masterData?.department || [])}
                            fluid
                            selection
                            clearable
                            value={formValues.departmentId ? formValues.departmentId : ''}
                            onChange={handleDropdownChange}
                            onBlur={handleDropdownBlur}
                          />
                        </div>
                      </Form.Field>
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <Form.Field>
                        <label>Support</label>
                        <div style={{ marginTop: 5 }}>
                          <Button.Group size='massive' className='custom-group-button'>
                            <Button className='thumbsUp' type="button" icon='thumbs up outline'
                              onClick={() => {
                                setSaveText(_.isEqual(oldFormValues, { ...formValues, supportStatusId: formValues.supportStatusId === 1 ? null : 1 }) ? 'Saved' : 'Unsaved');
                                setFormValues((prev: CaseViewModel) => { return { ...prev, supportStatusId: prev.supportStatusId === 1 ? null : 1 }; });
                              }}
                              active={formValues?.supportStatusId && formValues?.supportStatusId === 1 ? true : undefined} />
                            <Button className='thumbsDown' type="button" icon='thumbs down outline'
                              onClick={() => {
                                setSaveText(_.isEqual(oldFormValues, { ...formValues, supportStatusId: formValues.supportStatusId === 2 ? null : 2 }) ? 'Saved' : 'Unsaved');
                                setFormValues((prev: CaseViewModel) => { return { ...prev, supportStatusId: prev.supportStatusId === 2 ? null : 2 }; });
                              }}
                              active={formValues?.supportStatusId === 2 ? true : undefined} />
                          </Button.Group>
                        </div>
                      </Form.Field>
                      {caseNumber === 0 && (
                        <div className="field">
                          <label>Received date</label>
                          <SemanticDatepicker
                            id="emailReceivedDate"
                            format={'MM/DD/YYYY'}
                            onChange={(event, date) => handleDateChange(date, 'emailReceivedDate')}
                            value={formValues.emailReceivedDate ? new Date(formValues.emailReceivedDate) : new Date()}
                          />
                        </div>
                      )}
                      {formValues?.createdDate &&
                        <>
                          <Form.Field>
                            <label>Created</label>
                            <div style={{ marginTop: 5 }}>
                              {moment(formValues?.createdDate).format('MMM D, YYYY')} - {formValues.createdBy}
                            </div>
                          </Form.Field>
                          {formValues?.emailReceivedDate &&
                            <Form.Field>
                              <label>Received date</label>
                              <div style={{ marginTop: 5 }}>
                                {moment(formValues?.emailReceivedDate).format('MMM D, YYYY')}
                              </div>
                            </Form.Field>
                          }
                        </>
                      }
                    </Form.Group>
                    {formValues.attachments &&
                      <Grid>
                        <Grid.Column>
                          <div className={`field ${attachments?.isRequired ? 'required' : null}`}>
                            <label><Icon name="attach" />{attachments?.documentLabel ? attachments?.documentLabel : 'Attachments'}</label>
                            <FileUploadMultiple
                              caseId={caseNumber}
                              uniqueKey="case_attachments"
                              apiUrl={`/Upload/UploadFile`}
                              title={attachments?.documentLabel}
                              single={false}
                              readOnly={false}
                              handleUpdateDocument={handleAttachmentsChange}
                              serverAttachments={formValues.attachments}
                              maxFileSize={maxFileSize}
                              key={fileUploadKey}
                              isUpdated={fileUploadKey === 'file_upload_key' ? false : true}
                            />
                            {formErrors?.attachments && <span style={{ color: 'red' }}>{formErrors?.attachments}</span>}
                          </div>
                        </Grid.Column>
                      </Grid>
                    }
                    {caseNumber === 0 && (
                      <div className='field'>
                        <label>Internal Notes</label>
                        <TextArea
                          style={{ minHeight: 100 }}
                          name="notes"
                          value={formValues.notes ? formValues.notes : ''}
                          onChange={handleTextAreaChange}
                          onBlur={handleBlur}
                          maxLength={3000}
                        />
                      </div>
                    )}
                    {caseNumber === 0 && (
                      <Grid style={{ marginBottom: '1rem' }}>
                        <Grid.Column>
                          <Button type="submit" onClick={handleSubmit} className='violet right floated button' style={{ padding: '1.1rem 2.1rem', borderRadius: '0rem' }}>
                            Submit
                          </Button>
                          <Button type="button" className='second right floated button' style={{ padding: '1.1rem 2.1rem', borderRadius: '0rem', color: 'white' }} onClick={() => navigate('/dashboard')}>
                            Cancel
                          </Button>
                        </Grid.Column>
                      </Grid>
                    )}
                  </Dimmer.Dimmable>
                  {caseNumber > 0 && (
                    <>
                      <Dimmer.Dimmable as="div" dimmed={isNoteLoading}>
                        <Dimmer active={isNoteLoading} inverted={true}>
                          <Loader>Loading</Loader>
                        </Dimmer>
                        <div className='field'>
                          <label>Internal Notes</label>
                          <TextArea
                            style={{ minHeight: 100 }}
                            name="notes"
                            value={formValues.notes ? formValues.notes : ''}
                            onChange={handleTextAreaChange}
                            onBlur={handleBlur}
                            maxLength={3000}
                            onFocus={() => setIsNoteFocus(true)}
                          />
                          {noteFormErrors?.notes && <span style={{ color: 'red' }}>{noteFormErrors?.notes}</span>}
                        </div>
                        {isNoteFocus && (
                          <Grid>
                            <Grid.Column>
                              <Button type="submit" onClick={handleNoteSubmit} className='violet right floated button' style={{ padding: '1.1rem 2.1rem', borderRadius: '0rem' }}>
                                Save
                              </Button>
                              <Button type="button" className='second right floated button' style={{ padding: '1.1rem 2.1rem', borderRadius: '0rem', color: 'white' }} onClick={() => {
                                setIsNoteFocus(false);
                                setFormValues({ ...formValues, notes: '' });
                              }}>
                                Cancel
                              </Button>
                            </Grid.Column>
                          </Grid>
                        )}
                        {caseNoteResponse?.caseRecordNotes && (caseNoteResponse?.caseRecordNotes || []).length > 0 &&
                          <Grid>
                            <h2 style={{ marginTop: 10, marginBottom: 10 }}>Note history</h2>
                            <Grid.Row>
                              <Grid.Column>
                                <List className='communication-history' divided>
                                  {(caseNoteResponse?.caseRecordNotes || []).map((caseNote: CaseNotesViewModel, index) => {
                                    return (
                                      <CaseNote key={Math.random()} caseRecordId={formValues.caseRecordId} caseNote={caseNote} noteIndex={index} />
                                    )
                                  })}
                                </List>
                              </Grid.Column>
                            </Grid.Row>
                          </Grid>
                        }
                      </Dimmer.Dimmable>
                      {caseNumber > 0 && (
                        <Grid style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                          <Grid.Row>
                            <Grid.Column>
                              <span>Case ID: {formValues.caseRecordNumber}</span>
                              <span style={{ marginLeft: '3rem' }}>
                                <button
                                  title="Delete Case"
                                  style={{ color: '#e15247', backgroundColor: 'transparent', border: 'none' }}
                                  onClick={handleDelete}>
                                  Delete Case
                                </button>
                              </span>
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      )}
                    </>
                  )}
                </Form>
              </Grid.Column>
              {caseNumber > 0 && (
                <Grid.Column className='send-email' mobile={16} tablet={16} computer={7}>
                  <Dimmer.Dimmable as="div" dimmed={isHistoryLoading}>
                    <Dimmer active={isHistoryLoading} inverted={true}>
                      <Loader>Loading</Loader>
                    </Dimmer>
                    {communicationHistories?.length > 0 && (
                      <Grid className='mt-2 mb-1'>
                        <h2 style={{ marginBottom: 0 }}>Communication history ({communicationHistoryTotalCount})</h2>
                        <Grid.Row>
                          <Grid.Column>
                            {communicationHistories?.length === communicationHistoryCount && !isShowAllCommunicationNotes && (
                              <div onClick={() => {
                                fetchCommunicationHistory(0, formValues.caseRecordId, formValues.images);
                              }} className='cursor-pointer' style={{ textAlign: 'center', textDecoration: 'underline' }}>Show all</div>
                            )}
                          </Grid.Column>
                        </Grid.Row>
                        <Grid.Row style={{ marginBottom: '10px', maxHeight: (window.screen.availHeight - 450) + 'px', height: '100%', overflow: 'auto' }}>
                          <Grid.Column>
                            <List id='communicationHistory' className='communication-history' divided>
                              {communicationHistories?.map((communicationHistory, historyIndex) => {
                                const isShowCommunicationHistory = (historyIndex >= communicationHistories?.length - communicationHistoryCount || isShowAllCommunicationNotes) ? true : false;
                                return (
                                  <CommunicationHistory communicationHistory={communicationHistory} historyIndex={historyIndex} isShowCommunicationHistory={isShowCommunicationHistory} />
                                )
                              })}
                            </List>
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    )}
                    {privileges.includes(token_config.REPLY_TO_CONSTITUENTS) && (
                      <>
                        <div style={{ display: '-webkit-inline-box' }}>
                          {communicationHistories?.length === 0 && (
                            <h2>Send an email to the constituent</h2>
                          )}
                          {formValues?.constituent?.email && communicationHistories?.length > 0 && (
                            <h2>Reply to the constituent</h2>
                          )}
                          {draftEmail?.caseRecordDraftEmailHistoryId > 0 && <Label color='yellow' horizontal style={{ marginLeft: '1rem', marginTop: '0.5rem', fontSize: '1.2rem' }}>Draft</Label>}
                        </div>
                        {formValues?.constituent?.email && signatureMessage !== undefined &&
                          <>
                            <RichTextEditor onFocus={handleRichEmailEditorFocus} isFocus={isEmailFocus} onChange={handleRichEmailEditorChange} editorState={emailEditorState} rows={isEmailFocus ? 9 : 3} theme={isDarkTheme ? 'dark' : 'light'} ccEmails={ccEmails} setCcEmails={setCcEmails} selectedCcEmails={selectedCcEmails} setSelectedCcEmails={setSelectedCcEmails} />
                            {historyFormErrors?.communicationHistoryBody && <span style={{ color: 'red' }}>{historyFormErrors?.communicationHistoryBody}</span>}
                            {isEmailFocus && (
                              <>
                                <FileUploadMultiple
                                  caseId={caseNumber}
                                  uniqueKey="communication_attachments"
                                  apiUrl={`/Upload/UploadFile`}
                                  single={false}
                                  readOnly={false}
                                  handleUpdateDocument={handleCommunicationAttachmentsChange}
                                  serverAttachments={draftEmail && draftEmail.attachments}
                                  layout="simple"
                                  maxFileSize={maxFileSize}
                                />
                                <div className='mt-2'>
                                  <Button type="submit" onClick={saveCommunicationHistory} className='violet button' style={{ padding: '1.1rem 2.1rem', borderRadius: '0rem', backgroundColor: '#CAECF4', color: '#000000ab' }}>
                                    {isDraftEmailSaving ? 'Saving' : 'Save as Draft'}
                                  </Button>
                                  <Button type="button" className='second button' style={{ padding: '1.1rem 2.1rem', borderRadius: '0rem', color: 'white' }} onClick={handleRichEmailEditorBlur}>
                                    Cancel
                                  </Button>
                                  <Button type="submit" onClick={handleCommunicationHistorySubmit} className='violet button' style={{ padding: '1.1rem 2.1rem', borderRadius: '0rem' }}>
                                    Send
                                  </Button>
                                </div>
                              </>
                            )}
                          </>
                        }
                        {!formValues?.constituent?.email &&
                          <Message warning><p>To send a message, add an email address to this constituent's profile.</p></Message>
                        }
                      </>
                    )}
                  </Dimmer.Dimmable>
                  <Dimmer.Dimmable as="div" dimmed={isOtherCaseLoading}>
                    <Dimmer active={isOtherCaseLoading} inverted={true}>
                      <Loader>Loading</Loader>
                    </Dimmer>
                    {otherCases?.length > 0 && (
                      <Grid className='mt-2 mb-1'>
                        <Grid.Row>
                          <Grid.Column>
                            <h2 style={{ marginBottom: 0 }}>
                              <span>Other cases for {formValues?.constituent?.constituentName}</span>
                              {isShowAllOtherCases && (
                                <span onClick={() => {
                                  setIsOtherCaseLoading(true);
                                  setIsShowAllOtherCases(false);
                                  fetchOtherCases(3, formValues.caseRecordId, formValues.constituentId);
                                }} className='cursor-pointer' style={{ textDecoration: 'underline', float: 'right', fontSize: '1.6rem' }}>Hide</span>
                              )}
                            </h2>
                          </Grid.Column>
                        </Grid.Row>
                        <Grid.Row style={{ maxHeight: window.screen.availHeight + 'px', height: '100%', overflow: 'auto' }}>
                          <Grid.Column>
                            <div className="table-holder other-cases">
                              <Table>
                                <Table.Header>
                                  <Table.Row>
                                    <Table.HeaderCell style={{ width: '60%' }}>Subject</Table.HeaderCell>
                                    <Table.HeaderCell style={{ width: '28%' }}>Created</Table.HeaderCell>
                                    <Table.HeaderCell>Status</Table.HeaderCell>
                                  </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                  {otherCases?.map((otherCase, otherCaseIndex) => {
                                    return (
                                      <Table.Row key={`other-cases-${otherCaseIndex}`}>
                                        <Table.Cell><Link target='_blank' to={`/case/${otherCase.caseRecordId}`} style={{
                                          color: '#2d76d5',
                                          textDecoration: 'none'
                                        }}>{otherCase.subject}</Link></Table.Cell>
                                        <Table.Cell>{otherCase.created}</Table.Cell>
                                        <Table.Cell style={{ textAlign: 'center' }}>{statusIcon(otherCase.status)}</Table.Cell>
                                      </Table.Row>
                                    )
                                  })}
                                </Table.Body>
                              </Table>
                            </div>
                          </Grid.Column>
                        </Grid.Row>
                        {otherCases?.length !== otherCasesCount && !isShowAllOtherCases && (
                          <Grid.Row>
                            <Grid.Column>
                              <div onClick={() => {
                                setIsOtherCaseLoading(true);
                                fetchOtherCases(0, formValues.caseRecordId, formValues.constituentId);
                              }} className='cursor-pointer' style={{ textDecoration: 'underline', float: 'right' }}>View all</div>
                            </Grid.Column>
                          </Grid.Row>
                        )}
                      </Grid>
                    )}
                  </Dimmer.Dimmable>
                </Grid.Column>
              )}
            </Grid.Row>
          </Grid>
        </Dimmer.Dimmable>
      </div>
      {caseNumber > 0 && (
        <div style={{ display: 'none' }}>
          <div ref={printRef} className='print-block'>
            <div className="page-header" style={{ display: 'flex' }}>
              <div style={{ width: '90%' }}>
                <img src={imageLogo} style={{ width: 40, height: 40 }} />
                <span style={{ marginLeft: '1rem' }}>Adjure CRM - {formValues?.constituent?.constituentName} - {moment(formValues?.createdDate).format('MM/DD/YYYY')}</span>
              </div>
            </div>
            <Table style={{ marginTop: 0, border: 0 }}>
              <Table.Header>
                <Table.Row>
                  <Table.Cell className='no-border'>
                    <div className="page-header-space"></div>
                  </Table.Cell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell className='no-border'>
                    <Table celled className='print-constituent-info'>
                      <Table.Body>
                        <Table.Row className='header-row'>
                          <Table.HeaderCell colSpan='4'>Constituent information</Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className='font-weight-bold'>Date:</Table.Cell>
                          <Table.Cell>{moment(formValues?.createdDate).format('MM/DD/YYYY')}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className='font-weight-bold'>Constituent:</Table.Cell>
                          <Table.Cell>{formValues?.constituent?.constituentName}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className='font-weight-bold'>Phone Number:</Table.Cell>
                          <Table.Cell>{formValues?.constituent?.phoneNumber}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className='font-weight-bold'>Address:</Table.Cell>
                          <Table.Cell>{formValues?.constituent?.address}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className='font-weight-bold'>Ward:</Table.Cell>
                          <Table.Cell>{formValues?.constituent?.ward}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className='font-weight-bold'>Neighborhood:</Table.Cell>
                          <Table.Cell>{formValues?.constituent?.neighborhood}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                    <Table celled style={{ marginTop: '2rem' }} className='print-case-info'>
                      <Table.Body>
                        <Table.Row className='header-row'>
                          <Table.HeaderCell colSpan='4'>Case information</Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className='font-weight-bold'>Subject:</Table.Cell>
                          <Table.Cell colSpan='3'>{formValues?.subject}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className='font-weight-bold'>Case Description:</Table.Cell>
                          <Table.Cell colSpan='3' className='editor-content'>
                            <div dangerouslySetInnerHTML={{ __html: formValues.isHtmlOrPlainText ? (formValues.description || '').replace(/href/g, `target='_blank' href`) : (formValues.description || '').split('\n').join('<br/>') }} />
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className='font-weight-bold'>Status:</Table.Cell>
                          <Table.Cell>{formValues?.status}</Table.Cell>
                          <Table.Cell className='font-weight-bold'>Department:</Table.Cell>
                          <Table.Cell>{formValues?.department}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className='font-weight-bold'>Ward:</Table.Cell>
                          <Table.Cell>{formValues?.ward}</Table.Cell>
                          <Table.Cell className='font-weight-bold'>Neighborhood:</Table.Cell>
                          <Table.Cell>{formValues?.neighborhood}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className='font-weight-bold'>Assigned To:</Table.Cell>
                          <Table.Cell>{formValues?.assignedTo}</Table.Cell>
                          <Table.Cell className='font-weight-bold'>Support:</Table.Cell>
                          <Table.Cell>{formValues?.supportStatusId === 1 ? 'For' : (formValues?.supportStatusId === 2 ? 'Against' : '')}</Table.Cell>
                        </Table.Row>
                        {formValues?.attachments?.documents.length > 0 && (
                          <Table.Row>
                            <Table.Cell className='font-weight-bold'>Attachments:</Table.Cell>
                            <Table.Cell colSpan='3'>
                              {formValues?.attachments?.documents?.map((document: DocumentViewModel) => (
                                <div style={{ margin: '0.5rem' }}><Icon name='paperclip' /> {document.fileName}</div>
                              ))}
                            </Table.Cell>
                          </Table.Row>
                        )}
                      </Table.Body>
                    </Table>
                    {communicationHistories?.length > 0 && (
                      <Table celled style={{ marginTop: '2rem' }} className='print-message-info'>
                        <Table.Body>
                          <Table.Row className='header-row'>
                            <Table.HeaderCell colSpan='4'>Communication history</Table.HeaderCell>
                          </Table.Row>
                          {communicationHistories?.map((communicationHistory) => {
                            return (
                              <>
                                <Table.Row className='print-message-row-info'>
                                  <Table.Cell className='font-weight-bold no-border'>{moment(communicationHistory.createdDate).format('MMMM D, YYYY')} - {communicationHistory.name}</Table.Cell>
                                </Table.Row>
                                <Table.Row className='print-message-row-info'>
                                  <Table.Cell colSpan='4' className='editor-content'>
                                    <div className='replace-font-size' dangerouslySetInnerHTML={{ __html: communicationHistory.isHtmlOrPlainText ? communicationHistory.body?.replace(/href/g, `target='_blank' href`).replace('<br>\n</p>', '</p>\n<br>') : communicationHistory.body?.split('\n').join('<br/>') }} />
                                    {communicationHistory?.attachments?.documents?.map((document: DocumentViewModel) => (
                                      <div style={{ margin: '0.5rem' }}><Icon name='paperclip' /> {document.fileName}</div>
                                    ))}
                                  </Table.Cell>
                                </Table.Row>
                              </>
                            );
                          })}
                        </Table.Body>
                      </Table>
                    )}
                    {caseNoteResponse?.caseRecordNotes && (caseNoteResponse?.caseRecordNotes || []).length > 0 && (
                      <Table celled style={{ marginTop: '2rem' }} className='print-note-info'>
                        <Table.Body>
                          <Table.Row className='header-row'>
                            <Table.HeaderCell colSpan='4'>Note history</Table.HeaderCell>
                          </Table.Row>
                          {(caseNoteResponse?.caseRecordNotes || []).map((caseNote: CaseNotesViewModel) => {
                            return (
                              <>
                                <Table.Row className='print-note-row-info'>
                                  <Table.Cell className='font-weight-bold no-border'>{moment(caseNote.createdDate).format('MMMM D, YYYY')} - {caseNote.createdBy}</Table.Cell>
                                </Table.Row>
                                <Table.Row className='print-note-row-info'>
                                  <Table.Cell colSpan='4'>{caseNote.note}</Table.Cell>
                                </Table.Row>
                              </>
                            );
                          })}
                        </Table.Body>
                      </Table>
                    )}
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
              <Table.Footer>
                <Table.Row>
                  <Table.Cell className='no-border'>
                    <div className="page-footer-space"></div>
                  </Table.Cell>
                </Table.Row>
              </Table.Footer>
            </Table>
          </div>
        </div>
      )}
      <br />
    </section >
  );
}

export default CaseForm;